// extracted by mini-css-extract-plugin
export default {"modalStyle":"style_modalStyle__kVRLm","textStyle":"style_textStyle__6xYok"};